import React, { Component } from "react";
import { Card } from "./metrics-card";
import { Metrics } from "helpers/metrics/types";
import { DATATEST } from "constants/integration";
import { MetricsSectionContainer } from "./metrics-section-container";
import { MoveMetric } from "actions/tool-panel/draft/types";

type ReduxProps = {
    metrics: Metrics;
    moveMetric?: MoveMetric;
};
type OwnProps = {
    rollupAverageUnitsEnabled: boolean;
    isRollupMode: boolean;
    toggleShowOn: () => void;
};
export class MetricsListComponent extends Component<ReduxProps & OwnProps> {
    /**
     * `metrics` tracks the current selection state in the UI
     * metrics: [
     *  { showValue: true, kind: 'UNITS' },
     *  { showValue: true, kind: 'AVERAGE' },
     * ]
     *
     * Can't use object map b/c order matters
     * metrics: {
     *  UNITS: { showValue: true },
     *  AVERAGE: { showValue: true },
     * }
     *
     * What's the point of merchant preference `doorGroupMetrics`?
     * - It ought to set the default metrics toggle values if URL params do not exist
     * - It also provides additional properties such as `read_only` and `display_name`
     *
     */
    moveCard = (dragIndex, hoverIndex) => {
        const { moveMetric } = this.props;
        moveMetric({ dragIndex, hoverIndex });
    };

    render() {
        const { metrics, rollupAverageUnitsEnabled, isRollupMode, toggleShowOn } = this.props;
        return (
            <div className="metrics-list" data-test={DATATEST.TOOL_PANEL.DOORS.METRICS.METRICS_LIST}>
                {metrics.map((metric, index) => (
                    <Card key={metric.kind} id={metric.kind} index={index} moveCard={this.moveCard}>
                        <MetricsSectionContainer
                            label={metric.displayName}
                            metric={metric}
                            key={metric.kind}
                            index={index}
                            rollupAverageUnitsEnabled={rollupAverageUnitsEnabled}
                            isRollupMode={isRollupMode}
                            toggleShowOn={toggleShowOn}
                        />
                    </Card>
                ))}
            </div>
        );
    }
}
